// extracted by mini-css-extract-plugin
export var changeIcon = "_6w-4";
export var container = "_6w-0";
export var divider = "_6w-7";
export var externalLinkIcon = "_6w-1";
export var green = "_6w-5";
export var helpCircleIcon = "_6w-3";
export var iconButton = "_6w-2";
export var red = "_6w-6";